import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

export const FAQ = () => {
  const faqs = [
    {
      question: '¿Cómo invito a mis estudiantes?',
      answer: 'Es muy simple: creas tu aula en TuAsistencia y automáticamente se genera un link único. Comparte ese link por WhatsApp, email o cualquier medio que prefieras. Los estudiantes hacen clic, ingresan su nombre y quedan registrados en tu aula. En el plan Gratis puedes crear 1 aula e invitar hasta 30 estudiantes; en los planes Docente Pro y Panel de Coordinación no hay límites.'
    },
    {
      question: '¿Necesito instalar una app móvil?',
      answer: 'No, TuAsistencia funciona completamente en el navegador web. Tanto tú como tus estudiantes pueden acceder desde cualquier dispositivo con internet: celular, tablet o computador. Simplemente abre el navegador y listo.'
    },
    {
      question: '¿Funciona sin internet?',
      answer: 'Actualmente TuAsistencia requiere conexión a internet para registrar y sincronizar la asistencia. Estamos trabajando en una función offline que permitirá tomar asistencia sin conexión y sincronizar después.'
    },
    {
      question: '¿Mis datos están seguros?',
      answer: 'Sí. Implementamos medidas de seguridad estándar para proteger la información de docentes y estudiantes. Tus datos se almacenan de forma segura y no compartimos información con terceros.'
    },
    {
      question: '¿Qué pasa si varios docentes usan TuAsistencia en mi colegio?',
      answer: 'Cada docente puede usar su cuenta individual con el plan Docente Pro. Si la institución necesita supervisar múltiples docentes, coordinar reportes o acceder a analítica consolidada, recomendamos el Panel de Coordinación (complemento), que incluye un panel multi-docente y administración centralizada. No incluye licencias de docentes.'
    },
    {
      question: '¿Cómo se factura el plan anual?',
      answer: 'El plan anual se factura en un solo pago al inicio y aplica un descuento frente al pago mensual (17%). Puedes revisar los valores exactos en la sección de Planes.'
    },
    {
      question: '¿Puedo exportar mis reportes?',
      answer: 'En el plan Gratis tienes reportes básicos. La exportación de reportes (Excel y PDF) está disponible en los planes Docente Pro y Panel de Coordinación.'
    },
    {
      question: '¿Qué límites tiene el plan Gratis?',
      answer: 'El plan Gratis incluye hasta 1 aula y hasta 30 estudiantes, con registro de asistencia diaria, invitaciones por link y reportes básicos. Si necesitas exportación, analítica o uso sin límites, te conviene Docente Pro o Panel de Coordinación.'
    }
  ];

  return (
    <section id="faq" className="py-20 lg:py-28 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Preguntas <span className="text-blue-600">frecuentes</span>
            </h2>
            <p className="text-lg text-gray-600">
              Todo lo que necesitas saber sobre TuAsistencia
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-white border border-gray-200 rounded-xl px-6 shadow-sm hover:shadow-md transition-shadow duration-200"
              >
                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-blue-600 py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 text-center p-6 bg-blue-50 border border-blue-200 rounded-2xl">
            <p className="text-gray-700 mb-2">
              ¿Tienes más preguntas?
            </p>
            <a
              href="mailto:contacto@bitakora.com.co"
              className="text-blue-600 hover:text-blue-700 font-semibold underline"
            >
              Contáctanos en contacto@bitakora.com.co
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
